
import { Component, Mixins, Emit, Prop } from 'vue-property-decorator';

import BasicButton from '@/ui-components/BasicButton.vue';
import TitleWatchlistMutationMixin from '@/mixins/title-quick-action-mutations/TitleWatchlistMutationMixin.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
// BUYBOX_EXP_2
import { buyboxExp2TrackNotifyMeClick } from '@/components/experiments/buybox-exp-2/tracking';
// BUYBOX_EXP_2

// BUYBOX_EXP_3
import { buyboxExp3TrackNotifyMeClick } from '@/components/experiments/buybox-exp-3/tracking';
// BUYBOX_EXP_3

@Component({
	name: 'NoOfferBell',
	components: { BasicButton },
})
export default class NoOfferBell extends Mixins(TitleWatchlistMutationMixin) {
	@Prop({ default: true }) hasText: boolean;
	@Prop({ default: false }) isTitleInWatchlist: boolean;
	@Prop({ default: false }) inline: boolean;

	// BUYBOX_EXP_2
	@Prop() buyboxExp2ValidationPassed: boolean;
	// BUYBOX_EXP_2

	// BUYBOX_EXP_3
	@Prop() buyboxExp3ValidationPassed: boolean;
	// BUYBOX_EXP_3

	@Emit('onNotifyMe')
	onNotifyMe() {
		if (!this.isTitleInWatchlist) {
			TrackingHelper.trackEvent('userinteraction', { action: 'notify_me_clicked' });

			// BUYBOX_EXP_2
			if (this.buyboxExp2ValidationPassed) {
				const contexts = [...this.additionalContexts];
				buyboxExp2TrackNotifyMeClick(contexts);
			}
			// BUYBOX_EXP_2

			// BUYBOX_EXP_3
			if (this.buyboxExp3ValidationPassed) {
				const contexts = [...this.additionalContexts];
				buyboxExp3TrackNotifyMeClick(contexts);
			}
			// BUYBOX_EXP_3
		}
	}
}
